import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cbd2e00e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护车架信息")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}车架`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "车辆编号",
        prop: "vehicleCode"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.vehicleCode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.vehicleCode = $event),
          placeholder: "请输入车辆编号"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), $data.edit === false ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "仓库",
        prop: "warehouseId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          style: {
            "width": "100%"
          },
          modelValue: $data.formModel.warehouseId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.warehouseId = $event),
          filterable: "",
          remote: "",
          "reserve-keyword": "",
          placeholder: "请选择仓库",
          "remote-method": $options.remoteWarehouse,
          loading: _ctx.loading,
          onChange: $options.changeWarehouse
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.warehouses, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "remote-method", "loading", "onChange"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.edit === false && $data.formModel.warehouseId ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 1,
        label: "车架",
        prop: "frameId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          style: {
            "width": "100%"
          },
          modelValue: $data.formModel.frameId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.frameId = $event),
          filterable: "",
          remote: "",
          "reserve-keyword": "",
          placeholder: "请选择车架",
          "remote-method": $options.remoteFrame,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.frames, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.frameCode,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "remote-method", "loading"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.edit === false && $data.formModel.warehouseId ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 2,
        label: "电池",
        prop: "batteryId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          style: {
            "width": "100%"
          },
          modelValue: $data.formModel.batteryId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.batteryId = $event),
          filterable: "",
          remote: "",
          "reserve-keyword": "",
          placeholder: "请选择电池",
          "remote-method": $options.remoteBattery,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.batterys, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.batteryCode,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "remote-method", "loading"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.edit === false && $data.formModel.warehouseId ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 3,
        label: "中控",
        prop: "controllerId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          style: {
            "width": "100%"
          },
          modelValue: $data.formModel.controllerId,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.controllerId = $event),
          filterable: "",
          remote: "",
          "reserve-keyword": "",
          placeholder: "请选择中控",
          "remote-method": $options.remoteController,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.controllers, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.serialNumber,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "remote-method", "loading"])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['deviceFrame_add', 'deviceFrame_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}